import React, { Component } from 'react';
import styled from 'styled-components/macro';
import { WithTranslation, withTranslation } from 'react-i18next';

import { grid, colors, distances, zIndex } from '../../styles/constants';
import { H3 } from '../Typography';
import Icon from '../Icons';
import { Button } from '../Buttons';

export type OnChangeFunction = (event: Event) => void;

interface FilterSelectProps extends WithTranslation {
    name: string;
    disabled?: boolean;
    options: React.ReactNode[];
}

interface FilterSelectState {
    open: boolean;
}

class FilterSelect extends Component<FilterSelectProps, FilterSelectState> {
    wrapperRef: any = null;

    constructor(props: FilterSelectProps, context: any) {
        super(props, context);
        this.state = {
            open: false,
        };
        this.wrapperRef = React.createRef();
    }
    componentDidMount() {
        document.addEventListener('mousedown', this.handleClick);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClick);
    }

    setWrapperRef = (node: any) => {
        this.wrapperRef = node;
    };

    handleClick = (event: any) => {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.setState({ open: false });
        }
    };

    toggleOpen = () => {
        this.setState({ open: !this.state.open });
    };

    render() {
        const { name, options, t } = this.props;
        const { open } = this.state;

        return (
            <Wrapper ref={this.setWrapperRef}>
                <FilterButton id={name} name={name} onClick={this.toggleOpen} className="alt tiny with-icon">
                    <OffsetIcon icon="plus" />
                    {t('components.filters.filter_select.add_filter')}
                </FilterButton>
                <Options open={open} onClick={this.toggleOpen}>
                    <H3>{t('components.filters.filter_select.select_a_filter')}</H3>
                    {options}
                </Options>
            </Wrapper>
        );
    }
}

const Wrapper = styled.div`
    position: relative;
`;

const FilterButton = styled(Button)`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

const OffsetIcon = styled(Icon)`
    top: -1px;
    position: relative;
`;

interface OptionsProps {
    open: boolean;
}
const Options = styled.ul<OptionsProps>`
    min-width: ${grid.spans.span2};
    list-style: none;
    margin: 0;
    padding: ${distances.small};
    position: absolute;
    top: 0px;
    z-index: ${zIndex.top};
    background-color: ${colors.background};
    box-shadow: 0 0px 4px rgba(0, 0, 0, 0.2);
    transition: transform 150ms ease-out;
    transform-origin: top center;
    transform: ${props => (props.open ? 'scaleY(1)' : 'scaleY(0)')};

    > button {
        white-space: nowrap;
        width: 100%;
        margin-bottom: ${distances.tiny};
        text-align: left;
    }
`;
export default withTranslation()<React.ComponentType<FilterSelectProps>>(FilterSelect);
